import { render } from "./ActivitiesList.vue?vue&type=template&id=5d9f4592&scoped=true"
import script from "./ActivitiesList.vue?vue&type=script&lang=js"
export * from "./ActivitiesList.vue?vue&type=script&lang=js"

import "./ActivitiesList.vue?vue&type=style&index=0&id=5d9f4592&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9f4592"]])

export default __exports__